import { render, staticRenderFns } from "./AudioEnterReal.vue?vue&type=template&id=6a1c3545&scoped=true"
import script from "./AudioEnterReal.vue?vue&type=script&lang=ts"
export * from "./AudioEnterReal.vue?vue&type=script&lang=ts"
import style0 from "./AudioEnterReal.vue?vue&type=style&index=0&id=6a1c3545&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1c3545",
  null
  
)

export default component.exports